import { render, staticRenderFns } from "./PointOfSaleReportTable.vue?vue&type=template&id=7824d6b6&scoped=true&"
import script from "./PointOfSaleReportTable.vue?vue&type=script&lang=js&"
export * from "./PointOfSaleReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824d6b6",
  null
  
)

export default component.exports